module.exports = __webpack_public_path__ + "static/media/a-1-d.3da6ca08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/accessroies/a-1-d.jpg
// module id = 1091
// module chunks = 33